import React from "react";
import ServiceHero from "../../components/ServiceHero";

const MobileAppDevelopmentHome = () => (
  <ServiceHero
    eyebrow="Mobile App Development"
    title="Apps people love to"
    highlight="keep coming back to."
    description="From first concept to app-store launch, we create intuitive mobile products that feel effortless to use and are ready to grow with your business."
    features={[
      "iOS and Android expertise",
      "Intuitive, user-first journeys",
      "Built to scale securely",
    ]}
    image="/Images/mobileapp.png"
    imageAlt="Illustration of a user-friendly mobile application"
    visualLabel="Mobile experiences with momentum"
    visualTitle="Thoughtful products for the screens your customers use most."
  />
);

export default MobileAppDevelopmentHome;
